import React from 'react';
import styles from './Skeletons.module.css';

function RectangleSkeleton({ width, height }: { width?: string; height?: string }) {
    return <div className={styles.skeleton} style={{ width: width || 'inherit', height: height || 'inherit' }} />;
}

export default RectangleSkeleton;
